import { formatNumberWithCommas, unformatNumber } from "./helpers";
import EmailSection from "./EmailSection";

const regEmail     = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const PropertyDetails = ({
  handleChange,
  formData,
  setFormData,
  resetHandler,
  userParams, 
  setUserParams
}) => {
    

    // Commas to thousands
    const handleSalePriceChange = (e) => {
      const rawValue = unformatNumber(e.target.value);
      if (!isNaN(rawValue)) {
        setFormData({
          ...formData,
          salePrice: rawValue
        });
      }
    };
    const handleSellerAttorneyFeeChange = (e) => {
      const rawValue = unformatNumber(e.target.value);
      if (!isNaN(rawValue)) {
        setFormData({
          ...formData,
          sellerAttorneyFee: rawValue
        });
      }
    };

    return(
        <div id='left' className="col-12 col-md-10 col-lg-6">
            <h4>Property Details</h4>
            <div class="mb-3">
              <label for="sale_price" class="form-label">Sale price</label>
              <div className="input-wrapper">
                <input  id="sale_price" class="form-control form-control-lg"
                  type="text"
                  name="salePrice"
                  value={formatNumberWithCommas(formData.salePrice)}
                  onChange={handleSalePriceChange}
                />
              </div>
            </div>
            <div class="mb-3">
              <label for="sale_price" class="form-label">Property type</label>
              <select class="form-select form-select-lg" 
                name="propertyType"
                value={formData.propertyType}
                onChange={handleChange}
              >
                <option value="1">Condo</option>
                <option value="2">Co-op</option>
                <option value="3">1 to 3 Family House</option>
                <option value="4">4 Family House</option>
                <option value="5">5 or More Family House</option>
                <option value="6">Commercial Real Estate</option>
              </select>
            </div>
            <div class="form-check form-switch mb-3">
              <label class="form-check-label left-place" for="exstng_mortgage">Existing mortgage?</label>
              <div className="right-place">
                <input class="form-check-input" type="checkbox" role="switch" id="exstng_mortgage"
                  name="existingMortgage"
                  checked={formData.existingMortgage}
                  onChange={handleChange}
                />
                <label for="exstng_mortgage" class="form-label">NO/YES</label>
              </div>
            </div>
            <div class="form-check form-switch mb-3">
              <label class="form-check-label" for="attorney">Seller power of attorney?</label>
              <div className="right-place">
                <input class="form-check-input" type="checkbox" role="switch" id="attorney" 
                  name="sellerPowerOfAttorney"
                  checked={formData.sellerPowerOfAttorney}
                  onChange={handleChange}
                />
                <label for="attorney" class="form-label">NO/YES</label>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6 col-12">
                <label for="broker_comission" class="form-label">Broker commission (%)</label>
                <input type="number" id="broker_comission" class="form-control form-control-lg"
                  name="brokerCommission"
                  value={formData.brokerCommission}
                  onChange={handleChange}
                />
              </div>
              <div class="col-md-6 col-12">
                <label for="attorney_fee" class="form-label">Seller's attorney fee</label>
                <div className="input-wrapper">
                  <input type="text" id="attorney_fee" class="form-control form-control-lg" 
                    name="sellerAttorneyFee"
                    value={formatNumberWithCommas(formData.sellerAttorneyFee)}
                    onChange={handleSellerAttorneyFeeChange}
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3 pb-3 flip-tax">
              <div class="col col-md-6 col-lg-6">
                <label for="flip_tax" class="form-label">Building flip tax (%)</label>
                <div className="input-wrapper1">
                  <input type="number" id="flip_tax" class="form-control form-control-lg"
                    name="buildingFlipTaxPercent"
                    value={formData.buildingFlipTaxPercent}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            
            <span id="desktopEmail">
              <EmailSection 
                formData={formData}
                setFormData={setFormData}
                resetHandler={resetHandler}
                userParams={userParams} 
                setUserParams={setUserParams}
              />
            </span>

          </div>
    );
}

export default PropertyDetails;